module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABVElEQVQ4T6WTv0rEQBDGvy+pbLTxHRQhFjHZEGzERlsRPLT0Bew90ROt7CxE8Am8RhtBBRELIRBCioMTfQMLGysLyY6sJEcSI6fcFoHJ7Pzmmz9L1E4YhmNZlq0AmBGRaeMm+QzgybbtyyiKPsohLBuu687atn0MYKEOzu2HLMu20jTtFf4BwPO8PZKdXwIrv0WkkyTJ/rc681FKLYnIzV+CB5nJ5TiObxkEwbjWOgYwZcgA3oaAJnOlL5ZlKfq+vwaga4JywCvJTSOsBroDcCoiTqnUFpVSbRE5LAC5cxfAYqmZ15ZlXWmtT0ySAkByxyg4B9CqAYx5QHIOwCeAvohsN9zpNgJEZJ3kBsnHPMgRkR7Jo7ICU/qPEgDEJNsA5ms9uAdwZparXkKliSRXAThNkzAqAFxUmtgwxvchY5yojHHkRSqyjbTKBWSkx1RA/vucvwCok8EpFA61eQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/email.png
// module id = wF+D
// module chunks = 13